import { jsonToGeojson } from "@/utils";

export class TagilPtRouteController {
  constructor(parent) {
    const { $store, mapgl } = parent;

    this.parent = parent;
    this.$store = $store;
    this.map = mapgl;
    this.data = null;
    this.active = null;

    this.clickHandler = this.clickHandler.bind(this);
  }

  toggleItems() {
    if (this.parent.isPtRouteActive) this.getRoutesData();
    else this.removeItems();
  }

  // get data
  async getRoutesData() {
    try {
      if (!this.data) {
        const { data } = await this.$store.dispatch("REQUEST", {
          url: `TagilPublicTransport?format=routes`
        });

        data
          .filter(e => e.geom)
          .map(e => {
            e.title = e.long_name;
            return e;
          });

        this.data = data;
        this.addItems(this.data, "lines");
      } else {
        this.addItems(this.data, "lines");
      }
    } catch (e) {
      console.log(e);
    }
  }

  addItems(data, type) {
    if (type === "lines") {
      this.map.addSource("tagil_rt_routes", {
        type: "geojson",
        data: jsonToGeojson(data)
      });

      this.map.addLayer({
        id: "tagil_rt_routes_lines",
        source: "tagil_rt_routes",
        type: "line",
        paint: {
          "line-width": 2,
          "line-offset": 3,
          "line-color": "#3288bd"
        }
      });
      this.map.on("click", "tagil_rt_routes_lines", this.clickHandler);
    } else if (type === "points") {
      this.map.addSource("tagil_rt_stops", {
        type: "geojson",
        data: jsonToGeojson(data)
      });

      this.map.addLayer({
        id: "tagil_rt_stops_point",
        source: "tagil_rt_stops",
        type: "circle",
        layout: {},
        paint: {
          "circle-radius": {
            base: 1.75,
            stops: [[12, 6], [22, 180]]
          },
          "circle-color": "rgba(89, 214, 78, 0.1)",
          "circle-pitch-alignment": "map",
          "circle-stroke-color": "rgb(89, 214, 78)",
          "circle-stroke-width": 1
        }
      });
      this.map.on("click", "tagil_rt_stops_point", this.clickHandler);
    }
  }

  removeItems() {
    this.map.off("click", "tagil_rt_routes_lines", this.clickHandler);
    if (this.map.getLayer("tagil_rt_routes_lines"))
      this.map.removeLayer("tagil_rt_routes_lines");
    if (this.map.getSource("tagil_rt_routes"))
      this.map.removeSource("tagil_rt_routes");
    if (this.map.getLayer("tagil_rt_stops_point"))
      this.map.removeLayer("tagil_rt_stops_point");
    if (this.map.getSource("tagil_rt_stops"))
      this.map.removeSource("tagil_rt_stops");

    this.removeActive();
  }

  clickHandler(e) {
    const { x, y } = e.point;
    const bbox = [[x - 5, y - 5], [x + 5, y + 5]];
    const features = this.map.queryRenderedFeatures(bbox, {
      layers: ["tagil_rt_routes_lines"]
    });

    if (!features.length) return;
    const feature = features[0];
    const { properties } = feature;
    if (!properties.id) return;
    this.toggleActiveLayer(properties.id);
  }

  removeActive() {
    if (this.map.getLayer("tagil_rt_routes_lines_active"))
      this.map.removeLayer("tagil_rt_routes_lines_active");
    if (this.map.getSource("tagil_rt_routes_active"))
      this.map.removeSource("tagil_rt_routes_active");
    if (this.map.getLayer("tagil_rt_stops_point_active"))
      this.map.removeLayer("tagil_rt_stops_point_active");
    if (this.map.getSource("tagil_rt_stops_active"))
      this.map.removeSource("tagil_rt_stops_active");
  }

  prepareActiveData(data) {
    const routes = [
      {
        geom: data.geom,
        title: data.long_name,
        route_id: data.id
      }
    ];
    const stops = data.stops.map(e => {
      e.title = data.long_name;
      e.route_id = data.id;
      return e;
    });

    return {
      routes,
      stops
    };
  }

  async toggleActiveLayer(id) {
    this.removeActive();

    try {
      const { data } = await this.$store.dispatch("REQUEST", {
        url: `TagilPublicTransport?format=route&id=${id}`
      });
      const { routes, stops } = this.prepareActiveData(data);

      const routesData = routes.filter(e => e.route_id === id);
      const stopsData = stops.filter(e => e.route_id === id);

      this.map.addSource("tagil_rt_routes_active", {
        type: "geojson",
        data: jsonToGeojson(routesData)
      });

      this.map.addLayer({
        id: "tagil_rt_routes_lines_active",
        source: "tagil_rt_routes_active",
        type: "line",
        paint: {
          "line-width": 2,
          "line-offset": 3,
          "line-color": "rgb(255, 68, 140)"
        }
      });

      this.map.addSource("tagil_rt_stops_active", {
        type: "geojson",
        data: jsonToGeojson(stopsData)
      });

      this.map.addLayer({
        id: "tagil_rt_stops_point_active",
        source: "tagil_rt_stops_active",
        type: "circle",
        layout: {},
        paint: {
          "circle-radius": {
            base: 1.75,
            stops: [[12, 6], [22, 180]]
          },
          "circle-color": "rgba(255, 68, 140, 0.1)",
          "circle-pitch-alignment": "map",
          "circle-stroke-color": "rgb(255, 68, 140)",
          "circle-stroke-width": 1
        }
      });
    } catch (e) {
      console.log(e);
    }
  }
}
